export const BUBBLE_DESIGN = [
  'standard_small',
  'standard_medium',
  'standard_large',
  'expanded_small',
  'expanded_medium',
  'expanded_large',
];

export const WIDGET_EVENTS = {
  INIT: 'lc_widget:init',
  INITIALIZED: 'lc_widget:initialized',
  WIDGET_CREATED: 'lc_widget:widget-created',
  WIDGET_LOADED: 'lc_widget:widget-loaded',
  READY: 'lc_widget:ready',
  TOGGLE: 'lc_widget:toggle',
  ERROR: 'lc_widget:error',
  WARNING: 'lc_widget:warning',
  DESTROYED: 'lc_widget:destroyed',
  RESET: 'lc_widget:reset',
};
